import React, { Component } from 'react';

import { Button, Card, DataTable, DialogContainer, Grid, 
    TableBody, TableColumn, TableRow, TableHeader } from 'react-md';

import Api from '../../common/api';
import { formatQuantidade, formatCurrency, itemIdFormater } from '../../common/formaters';

import Message from '../../components/message';
import Breadcrumb from '../../components/Breadcrumb';
import { openSnackbar } from '../../components/message';

import { Item } from '../../models/Item';
import Filter from '../../components/Filter';
import ItemForm from '../../forms/ItemForm';
import EstoqueForm from '../../forms/EstoqueForm';

export default class Itens extends Component {

    constructor(props) {
        super(props);

        this.state = {
            itens: [],
            latestItem: [],
            visibleConfirm: false,
            visibleForm: false,
            visibleEstoqueForm: false,
            pageX: null, 
            pageY: null,
            selectedItem: new Item(),
            filter: "",
            itensTotal: ""
        };
    }

    componentDidMount() {
        this.getAll();
        this.getItensTotal();
    }

    render() {
        const { selectedItem, itens, latestItem, itensTotal, visibleForm, visibleEstoqueForm, pageX, pageY, visibleConfirm } = this.state;
        const confirmActions = [];
        confirmActions.push({ secondary: true, children: 'Cancelar', onClick: this.hideConfirm });
        confirmActions.push(<Button flat primary onClick={this.deleteItem}>Sim</Button>);

        return (
            <Grid>
                <Breadcrumb title="Itens" url="/itens"/>
                <Card tableCard className="md-cell md-cell--12 tw-card">
                    <div className="buttons__group">
                        <div className="left-group">
                            <Button type="button" raised primary iconChildren="add" onClick={this.handleNewClick} 
                                aria-controls="modal-form">
                                Novo
                            </Button>
                        </div>
                        <div className="right-group">
                            <Button type="button" raised iconChildren="archive" onClick={this.handleEstoqueCLick} 
                                disabled={this.hasSelected()} className="btn btn-primary" aria-controls="modal-form"> 
                                Entrada de estoque
                            </Button>
                            <Button type="button" raised iconChildren="edit" onClick={this.handleEditCLick} 
                                disabled={this.hasSelected()} className="btn btn-secondary" aria-controls="modal-form"> 
                                Editar
                            </Button>
                            <Button type="button" raised primary iconChildren="delete" onClick={this.handleDeleteCLick} 
                                disabled={this.hasSelected()} className="btn btn-danger" >
                                Excluir
                            </Button>
                        </div>
                    </div>
                    
                    <Filter onSearch={this.handleChangeFilter} placeholder="Pesquise por código ou descrição"/>

                    <div className="buttons__group">

                        <div className="left-group md-text--secondary" style={{margin:"0 0 0 60%", }}>
                            Tamanho do Estoque: {itensTotal.size ? formatQuantidade(itensTotal.size) : ""} 
                        </div>

                        <div className="right-group md-text--secondary" style={{margin:"0", }}>
                            Preço do Estoque: {itensTotal.value ? formatCurrency(itensTotal.value) : ""}
                        </div>

                    </div>
                    
                    <DataTable baseId="itens-list" className="tw-table" plain={true} responsive>
                        <TableHeader>
                            <TableRow>
                                <TableColumn>Código</TableColumn>
                                <TableColumn>Descrição</TableColumn>
                                <TableColumn>Quantidade</TableColumn>
                                <TableColumn className="column--currency">Custo</TableColumn>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                        { itens.map((item, index) => (
                            <TableRow key={index} onClick={this.handleItemClick(item)} aria-controls="modal-form" 
                                className={this.renderSelectedClass(item)}>
                                <TableColumn>{ itemIdFormater(item.id) }</TableColumn>
                                <TableColumn>{ item.nome }</TableColumn>
                                <TableColumn>{ formatQuantidade(item.quantidade) }</TableColumn>
                                <TableColumn className="column--currency">{ item.custo_unitario }</TableColumn>
                            </TableRow>
                        ))}
                        </TableBody>
                    </DataTable>
                </Card>
                            
                <ItemForm model={selectedItem} pageX={pageX} pageY={pageY} onSave={this.saveForm}
                    visible={visibleForm} onHide={this.hideForm} onChange={this.handleChangeItem}
                    item_id={latestItem[0] ? latestItem[0].id + 1 : "Primeiro Item"}/>

                <EstoqueForm model={selectedItem} pageX={pageX} pageY={pageY} onSave={this.saveEstoqueForm}
                    visible={visibleEstoqueForm} onHide={this.hideEstoqueForm} onChange={this.handleChangeItem}/>

                <DialogContainer id="confirm-dialog" visible={visibleConfirm}
                    onHide={this.hideConfirm} actions={confirmActions} title="Atenção" >
                    <p>Deseja realmente excluir esse registro?</p>
                </DialogContainer>
                
                <Message />
            </Grid>
        );
    }

    getAll = () => {
        Api.getAllItens()
        .then(response => response.json())
        .then(itens => this.setState({itens: itens.map(item => {
            item.custo_unitario = formatCurrency(item.custo_unitario);
            return item;
        }), latestItem: itens}))
        .catch(error => openSnackbar({ message: error }));
    }

    getItensTotal = () => {
        setTimeout(() => {
            Api.getItensTotal()
                .then(response => response.json())
                .then(itensTotal => this.setState({ itensTotal }))
                .catch(error => openSnackbar({ message: error }));
        })
    }

    handleSearch = filter => {
        Api.getAllItens(filter)
        .then(response => response.json())
        .then(itens => this.setState({itens: itens.map(item => {
            item.custo_unitario = formatCurrency(item.custo_unitario);
            return item;
        })}))
        .catch(error => openSnackbar({ message: error }));
    }

    handleChangeFilter = filter => {
        this.handleSearch(filter);
        this.setState({ filter });
    }
    
    handleChangeItem = value => {
        this.setState({ selectedItem: value });
    }

    handleItemClick = selectedItem => event => {
        this.setState({selectedItem});
        setTimeout(() => this.setState({selectedItem}), 100);
    }

    handleNewClick = event => {
        this.cleanSelectedItem();
        this.showForm(event);
    }

    handleEstoqueCLick = event => {
        this.showEstoqueForm(event);
    }

    handleEditCLick = event => {
        this.showForm(event);
    }

    handleDeleteCLick = () => {
        this.showConfirm();
    }

    deleteItem = () => {
        Api.deleteItem(this.state.selectedItem)
        .then(response => {
            if(response.status === 204)
                this.afterDeleteItem();
            else
                openSnackbar({ message: `Não foi possível excluir o item ${this.state.selectedItem.nome}, 
                                            o mesmo já foi utilizado em pedidos realizados` })
        })
        .catch(error => openSnackbar({ message: error }));
        this.hideConfirm();
    }

    hideForm = () => {
        this.setState({ visibleForm: false });
        this.cleanSelectedItem();
        this.handleChangeFilter(this.state.filter)
    }

    hideEstoqueForm = () => {
        this.setState({ visibleEstoqueForm: false });
        this.cleanSelectedItem();
    }

    showForm = (e) => {
        let { pageX, pageY } = e;
        if (e.changedTouches) {
            pageX = e.changedTouches[0].pageX;
            pageY = e.changedTouches[0].pageY;
        }
        this.setState({ visibleForm: true, pageX, pageY });
    }

    showEstoqueForm = (e) => {
        let { pageX, pageY } = e;
        if (e.changedTouches) {
            pageX = e.changedTouches[0].pageX;
            pageY = e.changedTouches[0].pageY;
        }
        this.setState({ visibleEstoqueForm: true, pageX, pageY });
    }

    showConfirm = () => {
        this.setState({ visibleConfirm: true });
      };
    
    hideConfirm = () => {
        this.setState({ visibleConfirm: false });
    };

    saveForm = item => {
        let selectedItem = new Item(item);
        selectedItem.beforeSave();
        Api.saveItem(selectedItem)
        .then(() => this.afterSaveForm())
        .catch(error => openSnackbar({ message: error }));
    }

    afterSaveForm = () => {
        openSnackbar({ message: 'Item salvo com sucesso' });
        this.hideForm();
        this.getItensTotal();
        this.handleChangeFilter(this.state.filter)
    }

    saveEstoqueForm = item => {
        let selectedItem = new Item(item);
        selectedItem.beforeSave();
        Api.saveItem(selectedItem)
        .then(() => this.afterEstoqueSaveForm())
        .catch(error => openSnackbar({ message: error }));
    }

    afterEstoqueSaveForm = () => {
        openSnackbar({ message: 'Item adicionado ao estoque com sucesso' });
        this.hideEstoqueForm();
        this.getItensTotal();
        this.handleChangeFilter(this.state.filter)
    }

    afterDeleteItem = () => {
        this.cleanSelectedItem();
        this.getItensTotal();
        this.handleChangeFilter(this.state.filter)
        openSnackbar({ message: 'Item Excluído com sucesso' });
    }

    cleanSelectedItem = () => {
        const selectedItem = new Item();
        this.setState({selectedItem});
    }

    renderSelectedClass = (item) => {
        return item.id === this.state.selectedItem.id ? "item-selected" : "";
    };

    hasSelected = () => this.state.selectedItem.id ? false : true;

}



// WEBPACK FOOTER //
// ./src/views/itens/Itens.js